module.exports = __webpack_public_path__ + "bb0516694276cb52f35c29a232646245.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow.svg
// module id = 2395
// module chunks = 0